module.exports = __webpack_public_path__ + "static/media/jan 21 rev_1648181936786.9abd7c29.jpg";